import { render, staticRenderFns } from "./BatchFeedDialog.vue?vue&type=template&id=07920eb8&scoped=true&"
import script from "./BatchFeedDialog.vue?vue&type=script&lang=js&"
export * from "./BatchFeedDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchFeedDialog.vue?vue&type=style&index=0&id=07920eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07920eb8",
  null
  
)

export default component.exports